import React from "react";
import { useTranslation } from "react-i18next";

const EventForm = ({
  isDarkMode,
  eventType,
  startHHMM,
  durationMin,
  opponentName,
  trainingLabel,
  trainingDescription,
  onTypeSelect,
  setStartHHMM,
  setEventPeriod,
  setDurationMin,
  setOpponentName,
  setTrainingLabel,
  setTrainingDescription,
  hhmmToMinutes,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Type Selection */}
      <div className="mb-3">
        <label className="block text-sm font-semibold mb-2">{t("calendar_ui.activity_type")}</label>
        <div className="flex justify-center space-x-3">
          <button
            onClick={() => onTypeSelect("match", "105")}
            className={`px-4 py-2 rounded-lg shadow-md transition ${
              eventType === "match"
                ? "bg-amber-500 text-white"
                : isDarkMode
                ? "bg-gray-700 text-white hover:bg-gray-600"
                : "bg-gray-200 text-black hover:bg-gray-300"
            }`}
          >
            ⚽ {t("calendar_ui.match")}
          </button>
          <button
            onClick={() => onTypeSelect("training", "90")}
            className={`px-4 py-2 rounded-lg shadow-md transition ${
              eventType === "training"
                ? "bg-sky-500 text-white"
                : isDarkMode
                ? "bg-gray-700 text-white hover:bg-gray-600"
                : "bg-gray-200 text-black hover:bg-gray-300"
            }`}
          >
            🏋️ {t("calendar_ui.training")}
          </button>
          <button
            onClick={() => onTypeSelect("rest", "")}
            className={`px-4 py-2 rounded-lg shadow-md transition ${
              eventType === "rest"
                ? "bg-slate-500 text-white"
                : isDarkMode
                ? "bg-gray-700 text-white hover:bg-gray-600"
                : "bg-gray-200 text-black hover:bg-gray-300"
            }`}
          >
            😴 {t("calendar_ui.rest")}
          </button>
        </div>
      </div>

      {/* Time & Duration */}
      {(eventType === "training" || eventType === "match") && (
        <div className="grid grid-cols-2 gap-3 mb-3">
          <div>
            <label className="block text-sm font-semibold mb-1">{t("calendar_ui.start_time")}</label>
            <input
              type="time"
              value={startHHMM}
              onChange={(e) => {
                setStartHHMM(e.target.value);
                const min = hhmmToMinutes(e.target.value);
                if (min !== null) {
                  setEventPeriod(min < 12 * 60 ? "morning" : "afternoon");
                }
              }}
              className={`w-full p-2 rounded-md border ${
                isDarkMode
                  ? "bg-gray-900 border-gray-700 text-white"
                  : "bg-white border-gray-300 text-black"
              }`}
            />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-1">{t("calendar_ui.duration")}</label>
            <input
              inputMode="numeric"
              value={durationMin}
              onChange={(e) => setDurationMin(e.target.value)}
              placeholder="90"
              className={`w-full p-2 rounded-md border ${
                isDarkMode
                  ? "bg-gray-900 border-gray-700 text-white"
                  : "bg-white border-gray-300 text-black"
              }`}
            />
          </div>
        </div>
      )}

      {/* Match - Opponent */}
      {eventType === "match" && (
        <div className="mb-3">
          <label className="block text-sm font-semibold mb-1">{t("calendar_ui.opponent")}</label>
          <input
            value={opponentName}
            onChange={(e) => setOpponentName(e.target.value)}
            placeholder={t("calendar_ui.opponent_placeholder")}
            className={`w-full p-2 rounded-md border ${
              isDarkMode
                ? "bg-gray-900 border-gray-700 text-white"
                : "bg-white border-gray-300 text-black"
            }`}
          />
        </div>
      )}

      {/* Training - Label & Description */}
      {eventType === "training" && (
        <div className="mb-3 space-y-3">
          <div>
            <label className="block text-sm font-semibold mb-1">{t("calendar_ui.session_name")}</label>
            <input
              value={trainingLabel}
              onChange={(e) => setTrainingLabel(e.target.value)}
              placeholder={t("calendar_ui.session_placeholder")}
              className={`w-full p-2 rounded-md border ${
                isDarkMode
                  ? "bg-gray-900 border-gray-700 text-white"
                  : "bg-white border-gray-300 text-black"
              }`}
            />
          </div>

          <div>
            <label className="block text-sm font-semibold mb-1">{t("calendar_ui.description")}</label>
            <textarea
              value={trainingDescription}
              onChange={(e) => setTrainingDescription(e.target.value)}
              rows={2}
              placeholder={t("calendar_ui.description_placeholder")}
              className={`w-full p-2 rounded-md border ${
                isDarkMode
                  ? "bg-gray-900 border-gray-700 text-white"
                  : "bg-white border-gray-300 text-black"
              }`}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default EventForm;
